<template>
  <el-popover placement="top-start" width="400" trigger="click">
    <div class="emotionList">
      <b @click="getEmo(idx)" v-for="(item,idx) in faceList" :key="idx" class="emotionItem">{{item}}</b>
    </div>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
import appData from "./emoji.json";

const changeSelectedText = (textArea, str) => {
  console.log("changeSelectedText",str);
  if (document.selection) {
    console.log("changeSelectedText22");

    // IE浏览器
    textArea.focus();
    var sel = document.selection.createRange();
    sel.text = str;
  }else if (window.getSelection) {
    console.log("changeSelectedText11",textArea.value);
    // 非IE浏览器
    textArea.setRangeText(str);
    // 在未选中文本的情况下，重新设置光标位置
    textArea.selectionStart += str.length;
    textArea.focus();

  }else {
    textArea.value += str;
  }  


};

export default {
  name: "Emoji",
  props: {
    textAreaId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      faceList: appData,
    };
  },
  mounted() {
    console.log("mounted");
  },
  methods: {
    getEmo(idx) {
      const textArea = document.getElementById(this.textAreaId);
      changeSelectedText(textArea, this.faceList[idx]);
    },
  },
};
</script>



<style scoped>
.emotionList {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  height: 200px;
  width: 400px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.emotionItem {
  width: 10%;
  font-size: 20px;
  text-align: center;
}
</style>
